import React from 'react'

const TranslatorApp = () => {
  return (
    <h1>TranslatorApp Page Header</h1>
  )
}

export default TranslatorApp
